import React, { useState } from "react";
import { FaPlay, FaPause } from "react-icons/fa";

const Poster = ({
  backgroundType,
  backgroundURL,
  thumbnailImage,
  featureVideo,
  detailSubheading,
}) => {
  // Set the thumbnail as background if background image is not available
  const backgroundImage =
    backgroundType === "IMAGE" && backgroundURL
      ? backgroundURL
      : thumbnailImage;

  const [isPlaying, setIsPlaying] = useState(true);
  const [isVideoReady, setIsVideoReady] = useState(false);

  // Handle play/pause toggle
  const togglePlay = () => {
    setIsPlaying((prev) => !prev);
  };

  return (
    <div className="relative w-full rounded-lg overflow-hidden">
      <div
        className="w-full h-48 bg-cover bg-center rounded-lg"
        style={{ backgroundImage: `url(${backgroundImage})` }}
      >
        {isPlaying && featureVideo && (
          // <video
          //   src={featureVideo}
          //   muted
          //   className="w-full h-48 object-cover rounded-lg"
          //   autoPlay
          //   loop
          //   onLoadedData={() => setIsVideoReady(true)}
          //   onEnded={() => setIsPlaying(false)}
          // />
          <video
            src={featureVideo}
            muted
            playsInline // <-- important for iOS
            className="w-full h-48 object-cover rounded-lg"
            autoPlay
            loop
            onLoadedData={() => setIsVideoReady(true)}
            onEnded={() => setIsPlaying(false)}
          />
        )}

        {featureVideo && (
          <button
            onClick={togglePlay}
            className="absolute bottom-10 right-4 flex items-center gap-2 bg-black bg-opacity-50 text-white px-4 py-2 rounded-full"
          >
            {isPlaying ? <FaPause size={16} /> : <FaPlay size={16} />}
            <span className="text-sm">{isPlaying ? "" : "Play"}</span>
          </button>
        )}
      </div>

      {detailSubheading && (
        <div className="p-2">
          <p className="text-xs text-gray-600">{detailSubheading}</p>
        </div>
      )}
    </div>
  );
};

export default React.memo(Poster);
